<template>
  <div>
    <span class="lib__h3 lib__text-gray-500">{{ $t('new-connection-cmh.energy-configuration-step.meterIndividual')
      }}</span>
    <div v-for="(item, n) in meters" :key="`${n}-flat-electricity`">
      <package-editable-box v-if="item.destination === 'residential'" :isElectricMeter="true" :isGasMeter="false"
        :packageKey="item.package && item.package.key" :isPriceToBeDetermined="item.customPower"
        :excludingVatPrice="item.package && item.package.buildingPrice && item.package.buildingPrice.exVat" :meterCount="item.count"
        :maximumPowerGuaranteed="item.package && item.package.maximumPower.kiloVoltAmpere"
        :selectedFunctionality="'meter.phase.' + item.connectionType" :identifier="n" :wantedPower="item.wantedPower"
        :buildingType="'building'" :onEdit="editElectricityBox" :onDelete="deleteElectricityBox"></package-editable-box>
    </div>
    <button :disabled="addButtonDisabled('residential')" @click="onAddNewMeter('residential')" type="button"
      :class="{ 'lib__btn--disabled': addButtonDisabled('residential') }" class="lib__btn-action">
      <span class="lib__badge lib__badge--primary"><i class="fas fa-plus"></i></span>
      <span class="lib__btn-action__label">{{
        $t('new-connection-cmh.energy-configuration-step.addAnotherIndividualMeter') }}</span>
    </button>

    <span class="lib__h3 lib__text-gray-500">{{ $t('new-connection-cmh.energy-configuration-step.meterCommon')
      }}</span>
    <div v-for="(item, n) in meters" :key="`${n}-common-electricity`">
      <package-editable-box v-if="item.destination === 'common'" :isElectricMeter="true" :isGasMeter="false"
        :packageKey="item.package && item.package.key" :isPriceToBeDetermined="item.customPower"
        :excludingVatPrice="item.package && item.package.buildingPrice && item.package.buildingPrice.exVat" :meterCount="item.count"
        :maximumPowerGuaranteed="item.package && item.package.maximumPower.kiloVoltAmpere"
        :selectedFunctionality="'meter.phase.' + item.connectionType" :identifier="n" :wantedPower="item.wantedPower"
        :buildingType="'building'" :onEdit="editElectricityBox" :onDelete="deleteElectricityBox"></package-editable-box>
    </div>
    <button :disabled="addButtonDisabled('common')" @click="onAddNewMeter('common')" type="button"
      :class="{ 'lib__btn--disabled': addButtonDisabled('common') }" class="lib__btn-action">
      <span class="lib__badge lib__badge--primary"><i class="fas fa-plus"></i></span>
      <span class="lib__btn-action__label">{{
        $t('new-connection-cmh.energy-configuration-step.addAnotherCommonMeter') }}</span>
    </button>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { PackagedElectricityMeter } from '@/models'
import PackageEditableBox from './PackageEditableBox.vue'
import AddConnectionEditableBox from './AddConnectionEditableBox.vue'
import PriceDisclaimer from './PriceDisclaimer.vue'

@Component({
  components: {
    PackageEditableBox,
    AddConnectionEditableBox,
    PriceDisclaimer
  },
  name: 'building-package-electricity'
})
export default class BuildingPackageElectricity extends Vue {
  @Prop({ type: Array, required: true }) public meters!: PackagedElectricityMeter[]

  @Prop({ type: Function, required: true }) public onAddNewMeter!: (destination: string) => void
  @Prop({ type: Function, required: true }) public deleteElectricityBox!: (identifier: number) => void
  @Prop({ type: Function, required: true }) public editElectricityBox!: (identifier: number) => void

  addButtonDisabled(meterDestination: string): boolean {
    const meters = this.meters.filter(meter => meter.destination === meterDestination)
    return meters.length > 9;
  }

}
</script>